if (typeof p80 === 'undefined') {
	var p80 = {};
}

class MediaQueryListener {
	constructor() {
		this.mediaTypes = {
			small: 'small',
			medium: 'medium',
			large: 'large',
			ultrawide: 'ultrawide',
			touch: 'touch'
		};
		this.mediaQueries = [
			{query: window.matchMedia('(max-width: 749px)'), type: 'small'},
			{
				query: window.matchMedia('(min-width: 750px) and (max-width: 989px)'),
				type: 'medium'
			},
			{query: window.matchMedia('(min-width: 990px) and (max-width: 1919px)'), type: 'large'},
			{query: window.matchMedia('(min-width: 1920px)'), type: 'ultrawide'},
			{query: window.matchMedia('(pointer: coarse)'), type: 'touch'}
		];

		this.touchSupport = window.matchMedia('(pointer: coarse)').matches;

		this.queryChangeHandler = this.onQueryChange.bind(this);

		this.currentMediaQuery = this.mediaQueries.find((queryOption) => {
			return queryOption.query.matches && queryOption.query.type !== this.mediaTypes.touch;
		});

		this.mediaQueries.forEach((queryOption) => {
			queryOption.query.addEventListener(
				'change',
				this.queryChangeHandler.bind(this, queryOption)
			);
		});

		document.addEventListener('DOMContentLoaded', this.publish());
	}

	onQueryChange(queryOption) {
		if (
			queryOption &&
			queryOption.query &&
			queryOption.query.matches &&
			this.currentMediaQuery.type === queryOption.type
		) {
			return;
		}

		if (queryOption.type !== this.mediaTypes.touch) {
			const previousMedia = this.currentMediaQuery;
			const newMedia = this.mediaQueries.find((queryOption) => {
				return queryOption.query.matches;
			});
			if (previousMedia && previousMedia.type === newMedia.type) return;
			this.currentMediaQuery = newMedia;
		} else {
			this.touchSupport = queryOption.query.matches;
		}

		this.publish();
	}

	publish() {
		if (typeof publish === 'undefined') return;
		publish(PUB_SUB_EVENTS.mediaQueryChange, {
			source: 'MediaQueryListener',
			currentMedia: this.currentMediaQuery,
			touchSupport: this.touchSupport
		});
	}
}

p80.mediaQueryService = new MediaQueryListener();

function getFocusableElements(container) {
	return Array.from(
		container.querySelectorAll(
			"summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
		)
	);
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
	summary.setAttribute('role', 'button');
	summary.setAttribute('aria-expanded', 'false');

	if (summary.nextElementSibling.getAttribute('id')) {
		summary.setAttribute('aria-controls', summary.nextElementSibling.id);
	}

	summary.addEventListener('click', (event) => {
		event.currentTarget.setAttribute(
			'aria-expanded',
			!event.currentTarget.closest('details').hasAttribute('open')
		);
	});

	if (summary.closest('header-drawer')) return;
	summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
	var elements = getFocusableElements(container);
	var first = elements[0];
	var last = elements[elements.length - 1];

	removeTrapFocus();

	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;

		document.addEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.focusout = function () {
		document.removeEventListener('keydown', trapFocusHandlers.keydown);
	};

	trapFocusHandlers.keydown = function (event) {
		if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
		// On the last focusable element and tab forward, focus the first element.
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}

		//  On the first focusable element and tab backward, focus the last element.
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};

	document.addEventListener('focusout', trapFocusHandlers.focusout);
	document.addEventListener('focusin', trapFocusHandlers.focusin);

	elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
	document.querySelector(':focus-visible');
} catch {
	focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
	const navKeys = [
		'ARROWUP',
		'ARROWDOWN',
		'ARROWLEFT',
		'ARROWRIGHT',
		'TAB',
		'ENTER',
		'SPACE',
		'ESCAPE',
		'HOME',
		'END',
		'PAGEUP',
		'PAGEDOWN'
	];
	let currentFocusedElement = null;
	let mouseClick = null;

	window.addEventListener('keydown', (event) => {
		if (navKeys.includes(event.code.toUpperCase())) {
			mouseClick = false;
		}
	});

	window.addEventListener('mousedown', (event) => {
		mouseClick = true;
	});

	window.addEventListener(
		'focus',
		() => {
			if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

			if (mouseClick) return;

			currentFocusedElement = document.activeElement;
			currentFocusedElement.classList.add('focused');
		},
		true
	);
}

function pauseAllMedia() {
	document.querySelectorAll('.js-youtube').forEach((video) => {
		video.contentWindow.postMessage(
			'{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
			'*'
		);
	});
	document.querySelectorAll('.js-vimeo').forEach((video) => {
		video.contentWindow.postMessage('{"method":"pause"}', '*');
	});
	document.querySelectorAll('video').forEach((video) => video.pause());
	document.querySelectorAll('product-model').forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}

function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener('focusin', trapFocusHandlers.focusin);
	document.removeEventListener('focusout', trapFocusHandlers.focusout);
	document.removeEventListener('keydown', trapFocusHandlers.keydown);

	if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== 'ESCAPE') return;

	const openDetailsElement = event.target.closest('details[open]');
	if (!openDetailsElement) return;

	const summaryElement = openDetailsElement.querySelector('summary');
	openDetailsElement.removeAttribute('open');
	summaryElement.setAttribute('aria-expanded', false);
	summaryElement.focus();
}

class QuantityInput extends HTMLElement {
	constructor() {
		super();
		this.input = this.querySelector('input');
		this.changeEvent = new Event('change', {bubbles: true});

		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onButtonClick.bind(this))
		);
	}

	onButtonClick(event) {
		event.preventDefault();
		const previousValue = this.input.value;

		event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
		if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
	}
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}

function fetchConfig(type = 'json') {
	return {
		method: 'POST',
		headers: {'Content-Type': 'application/json', Accept: `application/${type}`}
	};
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
	window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
	return function () {
		return fn.apply(scope, arguments);
	};
};

Shopify.setSelectorByValue = function (selector, value) {
	for (var i = 0, count = selector.options.length; i < count; i++) {
		var option = selector.options[i];
		if (value == option.value || value == option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};

Shopify.addListener = function (target, eventName, callback) {
	target.addEventListener
		? target.addEventListener(eventName, callback, false)
		: target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
	options = options || {};
	var method = options['method'] || 'post';
	var params = options['parameters'] || {};

	var form = document.createElement('form');
	form.setAttribute('method', method);
	form.setAttribute('action', path);

	for (var key in params) {
		var hiddenField = document.createElement('input');
		hiddenField.setAttribute('type', 'hidden');
		hiddenField.setAttribute('name', key);
		hiddenField.setAttribute('value', params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

	Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

	this.initCountry();
	this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
	initCountry: function () {
		var value = this.countryEl.getAttribute('data-default');
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},

	initProvince: function () {
		var value = this.provinceEl.getAttribute('data-default');
		if (value && this.provinceEl.options.length > 0) {
			Shopify.setSelectorByValue(this.provinceEl, value);
		}
	},

	countryHandler: function (e) {
		var opt = this.countryEl.options[this.countryEl.selectedIndex];
		var raw = opt.getAttribute('data-provinces');
		var provinces = JSON.parse(raw);

		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length == 0) {
			this.provinceContainer.style.display = 'none';
		} else {
			for (var i = 0; i < provinces.length; i++) {
				var opt = document.createElement('option');
				opt.value = provinces[i][0];
				opt.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(opt);
			}

			this.provinceContainer.style.display = '';
		}
	},

	clearOptions: function (selector) {
		while (selector.firstChild) {
			selector.removeChild(selector.firstChild);
		}
	},

	setOptions: function (selector, values) {
		for (var i = 0, count = values.length; i < values.length; i++) {
			var opt = document.createElement('option');
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};

class MenuDrawer extends HTMLElement {
	constructor() {
		super();

		this.mainDetailsToggle = this.querySelector('details');

		if (navigator.platform === 'iPhone')
			document.documentElement.style.setProperty(
				'--viewport-height',
				`${window.innerHeight}px`
			);

		this.addEventListener('keyup', this.onKeyUp.bind(this));
		this.addEventListener('focusout', this.onFocusOut.bind(this));
		this.bindEvents();
	}

	bindEvents() {
		this.querySelectorAll('summary').forEach((summary) =>
			summary.addEventListener('click', this.onSummaryClick.bind(this))
		);
		this.querySelectorAll('button').forEach((button) =>
			button.addEventListener('click', this.onCloseButtonClick.bind(this))
		);
	}

	onKeyUp(event) {
		if (event.code.toUpperCase() !== 'ESCAPE') return;

		const openDetailsElement = event.target.closest('details[open]');
		if (!openDetailsElement) return;

		openDetailsElement === this.mainDetailsToggle
			? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
			: this.closeSubmenu(openDetailsElement);
	}

	onSummaryClick(event) {
		const summaryElement = event.currentTarget;
		const detailsElement = summaryElement.parentNode;
		const isOpen = detailsElement.hasAttribute('open');
		const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

		function addTrapFocus() {
			trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
			summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
		}

		if (detailsElement === this.mainDetailsToggle) {
			if (isOpen) event.preventDefault();
			isOpen
				? this.closeMenuDrawer(event, summaryElement)
				: this.openMenuDrawer(summaryElement);
		} else {
			setTimeout(() => {
				detailsElement.classList.add('menu-opening');
				summaryElement.setAttribute('aria-expanded', true);
				!reducedMotion || reducedMotion.matches
					? addTrapFocus()
					: summaryElement.nextElementSibling.addEventListener(
							'transitionend',
							addTrapFocus
					  );
			}, 100);
		}
	}

	openMenuDrawer(summaryElement) {
		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});
		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
		if (this.closest('#main-collection-filters')) {
			this.closest('#main-collection-filters').classList.add('open');
		}
	}

	closeMenuDrawer(event, elementToFocus = false) {
		if (event !== undefined) {
			this.mainDetailsToggle.classList.remove('menu-opening');
			this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
				details.removeAttribute('open');
				details.classList.remove('menu-opening');
			});
			document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
			removeTrapFocus(elementToFocus);
			this.closeAnimation(this.mainDetailsToggle);
		}
	}

	onFocusOut(event) {
		setTimeout(() => {
			if (
				this.mainDetailsToggle.hasAttribute('open') &&
				!this.mainDetailsToggle.contains(document.activeElement)
			)
				this.closeMenuDrawer();
		});
	}

	onCloseButtonClick(event) {
		const detailsElement = event.currentTarget.closest('details');
		this.closeSubmenu(detailsElement);
	}

	closeSubmenu(detailsElement) {
		detailsElement.classList.remove('menu-opening');
		detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
		removeTrapFocus();
		this.closeAnimation(detailsElement);
	}

	closeAnimation(detailsElement) {
		let animationStart;

		const handleAnimation = (time) => {
			if (animationStart === undefined) {
				animationStart = time;
			}

			const elapsedTime = time - animationStart;

			if (elapsedTime < 400) {
				window.requestAnimationFrame(handleAnimation);
			} else {
				detailsElement.removeAttribute('open');

				if (detailsElement.closest('details[open]')) {
					trapFocus(
						detailsElement.closest('details[open]'),
						detailsElement.querySelector('summary')
					);
				} else if (this.closest('#main-collection-filters')) {
					this.closest('#main-collection-filters').classList.remove('open');
				}
			}
		};

		window.requestAnimationFrame(handleAnimation);
	}
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
	constructor() {
		super();
	}

	openMenuDrawer(summaryElement) {
		this.header = this.header || document.getElementById('shopify-section-header');
		this.borderOffset =
			this.borderOffset ||
			this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom')
				? 1
				: 0;
		document.documentElement.style.setProperty(
			'--header-bottom-position',
			`${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
		);

		setTimeout(() => {
			this.mainDetailsToggle.classList.add('menu-opening');
		});

		summaryElement.setAttribute('aria-expanded', true);
		trapFocus(this.mainDetailsToggle, summaryElement);
		document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
	}
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
	constructor() {
		super();
		if (this.querySelector('[data-close]')) {
			this.querySelector('[data-close]').addEventListener('click', this.hide.bind(this));
		}
		this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this));
		this.addEventListener('keyup', (event) => {
			if (!event.code) return;
			if (event.code.toUpperCase() === 'ESCAPE') this.hide();
		});
		if (this.classList.contains('media-modal')) {
			this.addEventListener('pointerup', (event) => {
				if (
					event.pointerType === 'mouse' &&
					!event.target.closest('deferred-media, product-modal')
				)
					this.hide();
			});
		} else {
			this.addEventListener('click', (event) => {
				if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
			});
		}
	}

	show(opener) {
		this.openedBy = opener;
		const popup = this.querySelector('.template-popup');
		document.body.classList.add('overflow-hidden');
		this.setAttribute('open', '');
		if (popup) popup.loadContent();
		trapFocus(this, this.querySelector('[role="dialog"]'));
		window.pauseAllMedia();
	}

	hide() {
		document.body.classList.remove('overflow-hidden');
		this.removeAttribute('open');
		removeTrapFocus(this.openedBy);
		window.pauseAllMedia();
	}
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
	constructor() {
		super();

		const button = this.querySelector('button') || this.querySelector('.card__inner');

		if (!button) return;
		button.addEventListener('click', () => {
			const modal = document.querySelector(this.getAttribute('data-modal'));
			if (modal) modal.show(button);
		});
	}
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
	constructor() {
		super();
		const poster = this.querySelector('[id^="Deferred-Poster-"]');
		if (!poster) return;
		poster.addEventListener('click', this.loadContent.bind(this));
	}

	loadContent() {
		window.pauseAllMedia();
		if (!this.getAttribute('loaded')) {
			const content = document.createElement('div');
			content.appendChild(
				this.querySelector('template').content.firstElementChild.cloneNode(true)
			);

			this.setAttribute('loaded', true);
			this.appendChild(content.querySelector('video, model-viewer, iframe')).focus();
		}
	}
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
	constructor() {
		super();
		this.slider = this.querySelector('ul');
		this.sliderItems = this.querySelectorAll('li');
		this.pageCount = this.querySelector('.slider-counter--current');
		this.pageTotal = this.querySelector('.slider-counter--total');
		this.prevButton = this.querySelector('button[name="previous"]');
		this.nextButton = this.querySelector('button[name="next"]');

		if (!this.slider || !this.nextButton) return;

		const resizeObserver = new ResizeObserver((entries) => this.initPages());
		resizeObserver.observe(this.slider);

		this.slider.addEventListener('scroll', this.update.bind(this));
		this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
		this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
	}

	initPages() {
		const sliderItemsToShow = Array.from(this.sliderItems).filter(
			(element) => element.clientWidth > 0
		);
		this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];
		if (sliderItemsToShow.length === 0) return;
		this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
		this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
		this.update();
	}

	update() {
		if (!this.pageCount || !this.pageTotal) return;
		this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

		if (this.currentPage === 1) {
			this.prevButton.setAttribute('disabled', 'disabled');
		} else {
			this.prevButton.removeAttribute('disabled');
		}

		if (this.currentPage === this.totalPages) {
			this.nextButton.setAttribute('disabled', 'disabled');
		} else {
			this.nextButton.removeAttribute('disabled');
		}

		this.pageCount.textContent = this.currentPage;
		this.pageTotal.textContent = this.totalPages;
	}

	onButtonClick(event) {
		event.preventDefault();
		const slideScrollPosition =
			event.currentTarget.name === 'next'
				? this.slider.scrollLeft + this.sliderLastItem.clientWidth
				: this.slider.scrollLeft - this.sliderLastItem.clientWidth;
		this.slider.scrollTo({
			left: slideScrollPosition
		});
	}
}

customElements.define('slider-component', SliderComponent);

/***
 *
 * Glide Component
 *
 * A slider implementation that can be utilized with only markup knowledge
 *
 * @param {boolean} (optional) data-disable
 * Will stop the slider logic from loading. Useful in scenarios where we only have a single slide e.g. a banner image.
 *
 * @param {number} (optional) data-animation-duration
 * The animation duration when changing slides
 *
 * @param {boolean} (optional) data-auto-rotate
 * Enables/Disables slider auto-rotation
 *
 * @param {number} (optional) data-auto-rotate-duration
 * The delay between changing slides when data-auto-rotate is TRUE
 *
 * @param {number} (optional) data-desktop-columns
 * The number of slides displayed on desktop. This can be a decimal/fraction.
 *
 * @param {number} (optional) data-tablet-columns
 * The number of slides displayed on tablet. This can be a decimal/fraction.
 *
 * @param {number} (optional) data-mobile-columns
 * The number of slides displayed on mobile. This can be a decimal/fraction.
 *
 * @param {number/string} (optional) data-focus-at
 * Where to focus the slider during/after animations. Almost always 0, however 'center' is an option
 *
 * @param {number} (optional) data-start-at
 * Which slide the slider starts at on initialization.
 *
 * @param {number} (optional) data-column-gap
 * How much space is injected between each slide (i.e. the grid)
 *
 * @param {string} (optional) data-pagination-style
 * what type of pagination do we render? (bullets, numbers, arrows)
 *
 * @param {boolean} (optional) data-pagination-desktop
 * Do we render pagination on desktop?
 *
 * @param {boolean} (optional) data-pagination-tablet
 * Do we render pagination on tablet?
 *
 * @param {boolean} (optional) data-pagination-mobile
 * Do we render pagination on mobile?
 *
 * @param {boolean} (optional) data-auto-resize
 * This is only intended for use with the markup in p80-slideshow.
 * This will automatically scale the slideshow height based on the current slide content.
 *
 * @param {boolean} (optional) data-wait-for-render
 * This will stop glide from initializing until it's manually called.
 * Sliders require their containing markup layout to be finalized before they can generate.
 * This parameter becomes useful when content is dynamically generated or injected on page.
 *
 */

class GlideComponent extends HTMLElement {
	static observedAttributes = [
		'data-disable',
		'data-animation-duration',
		'data-auto-rotate',
		'data-auto-rotate-duration',
		'data-desktop-columns',
		'data-tablet-columns',
		'data-mobile-columns',
		'data-focus-at',
		'data-start-at',
		'data-column-gap',
		'data-wait-for-render',
		'data-pagination-style',
		'data-pagination-desktop',
		'data-pagination-tablet',
		'data-pagination-mobile'
	];

	constructor() {
		super();
		this.connected = false;
		this.bound = false;
	}

	connectedCallback() {
		this.connected = true;
		this.currentMediaQuery = p80.mediaQueryService.currentMediaQuery;
		this.onResizeHandler = this.setHeight.bind(this);

		this.setConfiguration();
		this.setSubscriptions();

		if (this.disable) {
			this.classList.add('glide-component--disabled');
			this.classList.add('glide-component--loaded');
			this.hideLoader();
			if (this.autoResize) {
				document.addEventListener('DOMContentLoaded', this.onResizeHandler);
				this.resizeObserver = new ResizeObserver((entries) => {
					this.onResizeHandler(entries);
				});
				this.resizeObserver.observe(this.slider);
			}
			return;
		}

		// Manual keyboard navigation support - glide's default is "broken"
		this.onKeyUp = this.onKeyUp.bind(this);
		this.addEventListener('keyup', this.onKeyUp);

		const renderTasks = [
			this.initializeGlide.bind(this),
			this.generateBulletPagination.bind(this),
			this.generateArrowPagination.bind(this),
			this.generateNumberPagination.bind(this),
			this.bindGlide.bind(this),
			this.mountGlide.bind(this)
		];

		if (typeof Glide !== 'undefined') {
			this.yieldTasks(renderTasks);
		} else {
			this.onLoadHandler = this.yieldTasks.bind(this, renderTasks);
			document.addEventListener('DOMContentLoaded', this.onLoadHandler);
		}
	}

	disconnectedCallback() {
		this.connected = false;
		if (this.glideUpdateUnsubscriber) this.glideUpdateUnsubscriber();
		if (this.mediaQueryChangeUnsubscriber) this.mediaQueryChangeUnsubscriber();

		this.resizeObserver?.disconnect();
		this.removeEventListener('keyup', this.onKeyUp);
		document.removeEventListener('DOMContentLoaded', this.onLoadHandler);

		this.destroy();
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (!this.connected) return;
		const tasks = [
			this.setConfiguration.bind(this),
			this.initializeGlide.bind(this),
			this.generateBulletPagination.bind(this),
			this.generateArrowPagination.bind(this),
			this.generateNumberPagination.bind(this),
			this.bindGlide.bind(this),
			this.mountGlide.bind(this)
		];
		if (oldValue !== newValue) this.yieldTasks(tasks);
	}

	yieldToMain() {
		return new Promise((resolve) => {
			setTimeout(resolve, 0);
		});
	}

	async yieldTasks(tasks) {
		while (tasks.length > 0) {
			const task = tasks.shift();
			task();
			await this.yieldToMain();
		}
	}

	setSubscriptions() {
		this.glideUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.glideUpdate, (event) => {
			if (event.id !== this.id) return;
			this.onUpdateBroadcast(event);
		});

		this.mediaQueryChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.mediaQueryChange, (event) => {
			this.onMediaQueryChange(event);
		});
	}

	destroy() {
		try {
			this.glide?.destroy();
		} catch (error) {
			console.info(error);
		}
	}

	setConfiguration() {
		this.showLoader();
		this.classList.remove('glide-component--loaded');
		this.destroy();

		// Internal configs
		this.glide = null;
		this.id = this.getAttribute('data-id') ? this.getAttribute('data-id') : null;
		this.loader = this.querySelector('.slideshow__loader');
		this.disable = this.getAttribute('data-disable') === 'true' ? true : false;
		this.slider = this.querySelector('.glide');
		this.slides = this.querySelectorAll('.glide__slides > li');
		this.paginationStyles = {
			bullets: 'bullets',
			numbers: 'numbers',
			arrows: 'arrows'
		};

		// Slider configs
		const animationDuration = this.getAttribute('data-duration');
		this.animationDuration = !Number.isNaN(parseFloat(animationDuration, 10))
			? parseFloat(animationDuration, 10)
			: 400;

		this.autoRotate = this.getAttribute('data-auto-rotate') === 'true' ? true : false;
		const autoRotateDuration = this.getAttribute('data-auto-rotate-duration');
		this.autoRotateDuration = !Number.isNaN(parseFloat(autoRotateDuration, 10))
			? parseFloat(autoRotateDuration, 10)
			: 0;

		const desktopColumns = this.getAttribute('data-desktop-columns');
		// This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
		this.desktopColumns = !Number.isNaN(parseFloat(desktopColumns, 10))
			? parseFloat(desktopColumns, 10)
			: 1;

		this.largeDesktopColumns = this.desktopColumns;
		if (this.hasAttribute('data-large-desktop-columns')) {
			const largeDesktopColumns = this.getAttribute('data-large-desktop-columns');
			// This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
			this.largeDesktopColumns = !isNaN(parseFloat(largeDesktopColumns, 10))
				? parseFloat(largeDesktopColumns, 10)
				: this.desktopColumns;
		}
		this.ultraWideColumns = this.largeDesktopColumns;
		if (this.hasAttribute('data-ultrawide-columns')) {
			const ultraWideColumns = this.getAttribute('data-ultrawide-columns');
			// This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
			this.ultraWideColumns = !isNaN(parseFloat(ultraWideColumns, 10))
				? parseFloat(ultraWideColumns, 10)
				: this.largeDesktopColumns;
		}

		// This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
		const tabletColumns = this.getAttribute('data-tablet-columns');
		this.tabletColumns = !Number.isNaN(parseFloat(tabletColumns, 10))
			? parseFloat(tabletColumns, 10)
			: 1;

		const mobileColumns = this.getAttribute('data-mobile-columns');
		// This has to be a text field for decimal places - validate the user hasn't put in actual text before proceeding
		this.mobileColumns = !Number.isNaN(parseFloat(mobileColumns, 10))
			? parseFloat(mobileColumns, 10)
			: 1;

		const focusAt = this.getAttribute('data-focus-at');
		// focusAt can be an integer or string per glide docs - e.g. 'center'
		this.focusAt =
			focusAt === 'center'
				? focusAt
				: !Number.isNaN(parseFloat(focusAt, 10))
				? parseFloat(focusAt, 10)
				: 0;

		const startAt = this.getAttribute('data-start-at');
		this.startAt = !Number.isNaN(parseInt(startAt, 10)) ? parseInt(startAt, 10) : 0;

		const columnGap = this.getAttribute('data-column-gap');
		this.columnGap = !Number.isNaN(parseInt(columnGap, 10)) ? parseInt(columnGap, 10) : 24;

		// This is only intended for use via p80-slideshow
		this.autoResize = this.getAttribute('data-auto-resize') === 'true' ? true : false;

		this.waitForRender = this.getAttribute('data-wait-for-render') === 'true' ? true : false;

		this.desktopPagination =
			this.getAttribute('data-pagination-desktop') === 'true' ? true : false;
		this.tabletPagination =
			this.getAttribute('data-pagination-tablet') === 'true' ? true : false;
		this.mobilePagination =
			this.getAttribute('data-pagination-mobile') === 'true' ? true : false;

		const paginationStyle = this.getAttribute('data-pagination-style');
		this.paginationStyle = this.paginationStyles[paginationStyle]
			? this.paginationStyles[paginationStyle]
			: null;
	}

	onMediaQueryChange(event) {
		if (!event || !event.currentMedia) return;
		this.currentMediaQuery = event.currentMedia;
	}

	// This is only intended for use via p80-slideshow
	setHeight() {
		const activeSlide = this.glide ? this.slides[this.glide.index] : this.slides[0];
		const desktopImage = activeSlide?.querySelector('.slideshow__image--desktop');
		const mobileImage = activeSlide?.querySelector('.slideshow__image--mobile');
		const ultrawideImage = activeSlide?.querySelector('.slideshow__image--ultrawide');
		const activeText = activeSlide?.querySelector('.slideshow__content');
		const activeTextHeight = activeText ? activeText.scrollHeight : 0;
		let activeBreakpointMedia = desktopImage || null;
		if (this.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.small && mobileImage) {
			activeBreakpointMedia = mobileImage;
		} else if (
			this.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.ultrawide &&
			ultrawideImage
		) {
			activeBreakpointMedia = ultrawideImage;
		}
		const activeImageHeight = activeBreakpointMedia?.offsetHeight;

		if (!activeTextHeight || !activeImageHeight) return;

		const finalHeight =
			activeTextHeight > activeImageHeight ? activeTextHeight : activeImageHeight;

		this.style.setProperty('--height', `${finalHeight}px`);
	}

	onKeyUp(event) {
		if (!this.glide) return;
		const code = event.code ? event.code : event.keyCode;
		const right = [39, 'ArrowRight'];
		const left = [37, 'ArrowLeft'];

		const direction = right.includes(code) ? '>' : left.includes(code) ? '<' : null;
		if (!direction) return;

		this.glide.go(direction);
	}

	generateBulletPagination() {
		const bullets = this.querySelector('.glide__bullets');
		bullets?.remove();
		this.bullets = null;

		if (
			(this.paginationStyle !== this.paginationStyles.arrows &&
				this.paginationStyle !== this.paginationStyles.bullets) ||
			(this.paginationStyle === this.paginationStyles.arrows && !this.mobilePagination)
		) {
			return;
		}

		const container = document.createElement('div');
		container.classList.add('glide__bullets');
		container.setAttribute('data-glide-el', 'controls[nav]');
		if (!this.desktopPagination || this.paginationStyle === this.paginationStyles.arrows)
			container.classList.add('large-up-hide');
		if (!this.tabletPagination && this.paginationStyle !== this.paginationStyles.arrows)
			container.classList.add('medium-hide');
		if (!this.mobilePagination && this.paginationStyle !== this.paginationStyles.arrows)
			container.classList.add('small-hide');

		const desktopBullets = this.slides.length - (Math.floor(this.desktopColumns) - 1);
		const tabletBullets = this.slides.length - (Math.floor(this.tabletColumns) - 1);
		const mobileBullets = this.slides.length - (Math.floor(this.mobileColumns) - 1);
		this.slides.forEach((slide, index) => {
			const count = index + 1;
			const bullet = document.createElement('button');
			if (count > desktopBullets) bullet.classList.add('large-up-hide');
			if (count > tabletBullets) bullet.classList.add('medium-hide');
			if (count > mobileBullets) bullet.classList.add('small-hide');
			bullet.classList.add('glide__bullet');
			bullet.setAttribute('data-glide-dir', `=${index}`);
			bullet.setAttribute('title', `Slide ${count}`);
			container.appendChild(bullet);
		});

		this.querySelector('.glide').appendChild(container);
		this.bullets = this.querySelector('.glide__bullets');
	}

	generateNumberPagination() {
		const pagination = this.querySelector('.glide__pagination');
		const oldPreviousButton = pagination?.querySelector(`[aria-label="Previous"]`);
		const oldNextButton = pagination?.querySelector(`[aria-label="Next"]`);
		oldPreviousButton?.removeEventListener('click', this.previousSlideHandler);
		oldNextButton?.removeEventListener('click', this.nextSlideHandler);
		pagination?.remove();
		this.pagination = null;

		if (this.paginationStyle !== this.paginationStyles.numbers) return;

		const container = document.createElement('div');
		container.classList.add('glide__pagination');
		if (!this.desktopPagination) container.classList.add('large-up-hide');
		if (!this.tabletPagination) container.classList.add('medium-hide');
		if (!this.mobilePagination) container.classList.add('small-hide');

		const desktopPages = Math.max(
			this.slides.length - (Math.floor(this.desktopColumns) - 1),
			1
		);
		const tabletPages = Math.max(this.slides.length - (Math.floor(this.tabletColumns) - 1), 1);
		const mobilePages = Math.max(this.slides.length - (Math.floor(this.mobileColumns) - 1), 1);

		const prevButton = document.createElement('button');
		prevButton.setAttribute('type', 'button');
		prevButton.setAttribute('aria-label', 'Previous');
		prevButton.innerHTML = window.icons.caret;
		prevButton.addEventListener('click', this.previousSlideHandler);
		container.appendChild(prevButton);

		const count = document.createElement('p');
		count.setAttribute('data-count', true);
		const defaultCount = document.createElement('span');
		defaultCount.textContent = this.startAt + 1;
		container.appendChild(defaultCount);

		const divider = document.createElement('span');
		divider.textContent = '/';
		container.appendChild(divider);

		const desktop = document.createElement('span');
		desktop.classList.add('small-hide', 'medium-hide');
		desktop.textContent = `${desktopPages}`;
		container.appendChild(desktop);

		const tablet = document.createElement('span');
		tablet.classList.add('large-up-hide', 'small-hide');
		tablet.textContent = `${tabletPages}`;
		container.appendChild(tablet);

		const mobile = document.createElement('span');
		mobile.classList.add('large-up-hide', 'medium-hide');
		mobile.textContent = `${mobilePages}`;
		container.appendChild(mobile);

		const nextButton = document.createElement('button');
		nextButton.setAttribute('type', 'button');
		nextButton.setAttribute('aria-label', 'Next');
		nextButton.innerHTML = window.icons.caret;
		nextButton.addEventListener('click', this.nextSlideHandler);
		container.appendChild(nextButton);

		this.querySelector('.glide').appendChild(container);
		this.pagination = this.querySelector('.glide__pagination');
	}

	generateArrowPagination() {
		const arrows = this.querySelector('.glide__controls');
		arrows?.remove();
		this.arrows = null;

		if (this.paginationStyle !== this.paginationStyles.arrows) return;

		const container = document.createElement('div');
		container.classList.add('glide__controls');
		container.setAttribute('data-glide-el', 'controls');
		if (!this.desktopPagination) container.classList.add('large-up-hide');
		container.classList.add('medium-hide');
		// We will never display these on mobile due to space constraints
		container.classList.add('small-hide');

		const previous = document.createElement('button');
		previous.setAttribute('type', 'button');
		previous.classList.add('glide__previous');
		previous.setAttribute('data-glide-dir', '<');
		previous.setAttribute('aria-label', window.accessibilityStrings.previousSlide);
		previous.innerHTML = window.icons.play;
		container.appendChild(previous);

		const next = document.createElement('button');
		next.setAttribute('type', 'button');
		next.classList.add('glide__next');
		next.setAttribute('data-glide-dir', '>');
		next.setAttribute('aria-label', window.accessibilityStrings.nextSlide);
		next.innerHTML = window.icons.play;
		container.appendChild(next);
		this.querySelector('.glide').appendChild(container);
		this.arrows = this.querySelector('.glide__controls');
	}

	initializeGlide() {
		const component = this;
		this.glide = new Glide(component.slider, {
			type: 'slider',
			bound: true,
			animationDuration: component.animationDuration,
			focusAt: component.focusAt,
			startAt: component.startAt,
			perView: component.ultraWideColumns,
			gap: component.columnGap,
			autoplay: component.autoRotate ? component.autoRotateDuration : false,
			// Glide binds this to a global listener - using default keyboard navigation controls *every* slider on the page, regardless of focus
			// We create a manual scoped binding instead
			keyboard: false,
			breakpoints: {
				749: {
					perView: component.mobileColumns,
					gap: component.columnGap
				},
				1199: {
					perView: component.tabletColumns,
					gap: component.columnGap
				},
				1919: {
					perView: component.desktopColumns,
					gap: component.columnGap
				},
				2559: {
					perView: component.largeDesktopColumns,
					gap: component.columnGap
				}
			}
		});
		this.nextSlideHandler = () => this.glide.go('>');
		this.previousSlideHandler = () => this.glide.go('<');
	}

	bindGlide() {
		this.glide.on('mount.after', () => {
			this.glide.isMounted = true;
		});

		this.glide.on('move.after', () => {
			const currentSlideIndicator = this.pagination?.querySelector('span');
			if (currentSlideIndicator)
				Math.max((currentSlideIndicator.textContent = this.glide.index + 1), 1);
			if (this.autoResize) {
				this.onResizeHandler();
			}
		});

		if (this.autoResize) {
			this.glide.on('resize', () => {
				this.onResizeHandler();
			});
		}

		this.glide.on('build.after', () => {
			if (this.autoResize) {
				this.onResizeHandler();
			}
			this.classList.add('glide-component--loaded');
			this.hideLoader();
			this.showPagination();
		});
	}

	mountGlide() {
		this.glide.mount();
	}

	showPagination() {
		this.bullets?.classList.add('glide__bullets--visible');
		this.pagination?.classList.add('glide__pagination--visible');
		this.arrows?.classList.add('glide__controls--visible');
	}

	hidePagination() {
		this.bullets?.classList.remove('glide__bullets--visible');
		this.pagination?.classList.remove('glide__pagination--visible');
		this.arrows?.classList.remove('glide__controls--visible');
	}

	showLoader() {
		this.loader?.classList.add('slideshow__loader--visible');
	}

	hideLoader() {
		this.loader?.classList.remove('slideshow__loader--visible');
	}

	onUpdateBroadcast() {
		if (this.glide && this.glide.isMounted) return;
		if (this.waitForRender) {
			this.waitForRender = false;
			if (!this.slides || !this.slides.length) {
				this.slides = this.querySelectorAll('.glide__slides > li');
			}
			const tasks = [
				this.initializeGlide.bind(this),
				this.generateBulletPagination.bind(this),
				this.generateArrowPagination.bind(this),
				this.generateNumberPagination.bind(this),
				this.bindGlide.bind(this),
				this.mountGlide.bind(this)
			];
			this.yieldTasks(tasks);
		}
	}
}
customElements.define('glide-component', GlideComponent);

class ProjectIdeas extends GlideComponent {
	constructor() {
		super();
	}
	extend() {
		const slider = this;
		const parent = slider.closest('.project-ideas');
		if (!parent) return;
		const buttons = parent.querySelectorAll('[data-style]');
		slider.glide.on('move.after', () => {
			const activeSlide = slider.querySelector('.glide__slide--active');
			if (!activeSlide) return;
			const style = activeSlide.getAttribute('data-slide');
			if (!style) return;
			buttons.forEach((button) => {
				buttons.forEach((button) => {
					const buttonStyle = button.getAttribute('data-style');
					if (buttonStyle != style) {
						button.classList.remove('project-ideas__button--active');
					} else {
						button.classList.add('project-ideas__button--active');
					}
				});
			});
		});
	}
}

customElements.define('project-ideas', ProjectIdeas);

class VariantSelects extends HTMLElement {
	constructor() {
		super();
		this.addEventListener('change', this.onVariantChange);
	}

	connectedCallback() {
		this.setVariantGroups();
	}

	onVariantChange(event) {
		this.updateOptions();
		this.updateMasterId();
		if (this.determineRedirect()) {
			this.toggleAddButton(true, '', true);
			const redirect = this.generateRedirect(event);
			if (redirect) window.location.href = redirect;
			return;
		}
		this.updateSelectedSwatchValue(event);
		this.toggleAddButton(true, '', false);
		this.updatePickupAvailability();
		this.removeErrorMessage();
		this.updateVariantStatuses();
		this.updateChannelSight();
		this.updateAffirm();
		this.updateSofaArrangements();

		if (!this.currentVariant) {
			this.toggleAddButton(true, '', true);
			this.setUnavailable();
		} else {
			this.updateURL();
			this.updateVariantInput();
			this.renderProductInfo();
			this.updateShareUrl();
		}
	}

	generateRedirect(event) {
		if (!event) return;
		let selectedIndex = event.target.getAttribute('data-index');
		if (!selectedIndex) return;
		selectedIndex = parseInt(selectedIndex, 10);

		const selectedValue = event.target.getAttribute('value');
		if (!selectedValue) return;

		let redirect = `/products`;

		const childJson = this.querySelectorAll('[type="application/json"]');
		if (!childJson[1] || !childJson[2]) return;

		const childHandles = JSON.parse(childJson[2].textContent);
		const childProducts = JSON.parse(childJson[1].textContent);

		let matchingProduct;
		let matchingVariant;
		let matchingVariantIndex = -1;
		let matchingProductIndex = -1;
		// First look for an exact match for all options
		matchingProduct = childProducts.find((childVariants, productIndex) => {
			return childVariants.find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
		});
		if (matchingProduct) {
			matchingVariant = matchingProduct.find((variant) => {
				return !variant.options
					.map((option, index) => {
						return this.options[index] === option;
					})
					.includes(false);
			});
			if (matchingVariant) {
				matchingProductIndex = childProducts.indexOf(matchingProduct);
			}
		}

		// If no exact matches loose match based on the selected value
		if (!matchingProduct || !matchingVariant) {
			matchingProduct = childProducts.find((childVariants, productIndex) => {
				return childVariants.find((variant, variantIndex) => {
					return variant.options.find((option, optionIndex) => {
						if (optionIndex == selectedIndex && option === selectedValue) {
							matchingVariantIndex = variantIndex;
							matchingProductIndex = productIndex;
							return true;
						}
						return false;
					});
				});
			});
			matchingVariant =
				matchingProduct && matchingProduct.length && matchingVariantIndex >= 0
					? matchingProduct[matchingVariantIndex]
					: null;
		}

		if (!matchingProduct || !matchingVariant) return;

		const matchingHandle = childHandles[matchingProductIndex];
		if (!matchingHandle) return;
		redirect += `/${matchingHandle}`;

		if (!matchingVariant) return;

		redirect += `?variant=${matchingVariant.id}`;

		return redirect;
	}

	determineRedirect() {
		if (this.currentVariant) return false;
		return true;
	}

	updateSofaArrangements() {
		const arrangement = this.closest('product-info')?.querySelector('sofa-arrangements');
		arrangement?.updateActive();
	}

	updateChannelSight() {
		if (!this.currentVariant) return;
		const channelsight = this.closest('product-info')?.querySelector('channelsight-retailers');
		channelsight?.setAttribute('data-barcode', this.currentVariant.barcode);
	}

	updateAffirm() {
		if (!this.currentVariant) return;
		if (typeof affirm === typeof undefined) return;
		const affirmHolder = this.closest('product-info')?.querySelector(
			`[data-page-type="product"]`
		);
		if (!affirmHolder) return;
		affirmHolder.setAttribute('data-amount', this.currentVariant.price);
		affirm.ui.refresh();
	}

	updateOptions() {
		this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
			if (element.tagName === 'SELECT') {
				return element.value;
			}
			if (element.tagName === 'FIELDSET') {
				return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)
					?.value;
			}
		});
	}

	updateMasterId() {
		this.currentVariant = this.getVariantData().find((variant) => {
			return !variant.options
				.map((option, index) => {
					return this.options[index] === option;
				})
				.includes(false);
		});
	}

	updateSelectedSwatchValue({target}) {
		const {name, value, tagName} = target;

		if (tagName === 'SELECT' && target.selectedOptions.length) {
			const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
			const selectedDropdownSwatchValue = this.querySelector(
				`[data-selected-dropdown-swatch="${name}"] > .swatch`
			);
			if (!selectedDropdownSwatchValue) return;
			if (swatchValue) {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
				selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
			} else {
				selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
				selectedDropdownSwatchValue.classList.add('swatch--unavailable');
			}
		} else if (tagName === 'INPUT' && target.type === 'radio') {
			const selectedSwatchValue = this.querySelector(
				`[data-selected-swatch-value="${name}"]`
			);
			if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
		}
	}

	updateURL() {
		if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
		window.history.replaceState(
			{},
			'',
			`${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateShareUrl() {
		const shareButton = document.getElementById(`Share-${this.dataset.section}`);
		if (!shareButton || !shareButton.updateUrl) return;
		shareButton.updateUrl(
			`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
		);
	}

	updateVariantInput() {
		const productForms = document.querySelectorAll(
			`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
		);
		productForms.forEach((productForm) => {
			const input = productForm.querySelector('input[name="id"]');
			input.value = this.currentVariant.id;
			input.dispatchEvent(new Event('change', {bubbles: true}));
		});
	}

	updateVariantGroupOptions() {
		const childJson = this.querySelectorAll('[type="application/json"]');
		if (!childJson[3]) return;
		this.groupOptions = JSON.parse(childJson[3].textContent);
	}

	setVariantGroups() {
		if (!this.groupOptions) this.updateVariantGroupOptions();
		const fieldsets = this.querySelectorAll('fieldset');
		fieldsets.forEach((fieldset, index) => {
			const matchingValues = this.groupOptions[index]?.values;
			if (!matchingValues) return;
			const inputs = fieldset.querySelectorAll('input');
			inputs.forEach((input) => {
				const value = input.value;
				if (matchingValues.includes(value)) {
					input.classList.add('custom-swatch--group');
				} else {
					input.classList.remove('custom-swatch--group');
				}
			});
		});
	}

	updateVariantStatuses() {
		const selectedOptionOneVariants = this.variantData.filter(
			(variant) => this.querySelector(':checked').value === variant.option1
		);
		const inputWrappers = [...this.querySelectorAll('.product-form__input')];
		inputWrappers.forEach((option, index) => {
			if (index === 0) return;
			const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
			const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
			const availableOptionInputsValue = selectedOptionOneVariants
				.filter(
					(variant) =>
						variant.available && variant[`option${index}`] === previousOptionSelected
				)
				.map((variantOption) => variantOption[`option${index + 1}`]);
			this.setInputAvailability(optionInputs, availableOptionInputsValue);
		});
	}

	setInputAvailability(elementList, availableValuesList) {
		elementList.forEach((element) => {
			const value = element.getAttribute('value');
			const availableElement = availableValuesList.includes(value);

			if (element.tagName === 'INPUT') {
				element.classList.toggle('disabled', !availableElement);
			} else if (element.tagName === 'OPTION') {
				element.innerText = availableElement
					? value
					: window.variantStrings.unavailable_with_option.replace('[value]', value);
			}
		});
	}

	updatePickupAvailability() {
		const pickUpAvailability = document.querySelector('pickup-availability');
		if (!pickUpAvailability) return;

		if (this.currentVariant && this.currentVariant.available) {
			pickUpAvailability.fetchAvailability(this.currentVariant.id);
		} else {
			pickUpAvailability.removeAttribute('available');
			pickUpAvailability.innerHTML = '';
		}
	}

	removeErrorMessage() {
		const section = this.closest('section');
		if (!section) return;

		const productForm = section.querySelector('product-form');
		if (productForm) productForm.handleErrorMessage();
	}

	updateMedia(html) {
		const mediaGallerySource = document.querySelector(
			`[id^="MediaGallery-${this.dataset.section}"] ul`
		);
		const mediaGalleryDestination = html.querySelector(
			`[id^="MediaGallery-${this.dataset.section}"] ul`
		);

		const thumbnailGallerySource = document.querySelector(
			`[id^="GalleryThumbnails-${this.dataset.section}"] ul`
		);
		const thumbnailGalleryDestination = html.querySelector(
			`[id^="GalleryThumbnails-${this.dataset.section}"] ul`
		);

		const refreshSourceData = () => {
			const mediaGallerySourceItems = Array.from(
				mediaGallerySource.querySelectorAll('li[data-media-id]')
			);
			const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
			const sourceMap = new Map(
				mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, {item, index}])
			);

			return [mediaGallerySourceItems, sourceSet, sourceMap];
		};

		const refreshThumbnailSourceData = () => {
			const mediaGallerySourceThumbnails = Array.from(
				thumbnailGallerySource.querySelectorAll('li[data-thumbnail-media-id]')
			);
			const sourceSetThumbnails = new Set(
				mediaGallerySourceThumbnails.map((item) => item.dataset.thumbnailMediaId)
			);
			const sourceMapThumbnails = new Map(
				mediaGallerySourceThumbnails.map((item, index) => [
					item.dataset.thumbnailMediaId,
					{item, index}
				])
			);

			return [mediaGallerySourceThumbnails, sourceSetThumbnails, sourceMapThumbnails];
		};

		if (mediaGallerySource && mediaGalleryDestination) {
			let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
			const mediaGalleryDestinationItems = Array.from(
				mediaGalleryDestination.querySelectorAll('li[data-media-id]')
			);
			const destinationSet = new Set(
				mediaGalleryDestinationItems.map(({dataset}) => dataset.mediaId)
			);

			let shouldRefresh = false;

			// add items from new data not present in DOM
			for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
				if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
					mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
					shouldRefresh = true;
				}
			}

			// remove items from DOM not present in new data
			for (let i = 0; i < mediaGallerySourceItems.length; i++) {
				if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
					mediaGallerySourceItems[i].remove();
					shouldRefresh = true;
				}
			}

			// refresh
			if (shouldRefresh) {
				[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
			}

			// if media galleries don't match, sort to match new data order
			mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
				const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

				if (sourceData && sourceData.index !== destinationIndex) {
					mediaGallerySource.insertBefore(
						sourceData.item,
						mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
					);

					// refresh source now that it has been modified
					[mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
				}
			});
		}

		if (thumbnailGalleryDestination && thumbnailGallerySource) {
			let [mediaGallerySourceThumbnails, sourceSetThumbnails, sourceMapThumbnails] =
				refreshThumbnailSourceData();
			const mediaGalleryDestinationThumbnails = Array.from(
				thumbnailGalleryDestination.querySelectorAll('li[data-thumbnail-media-id]')
			);
			const destinationSetThumbnails = new Set(
				mediaGalleryDestinationThumbnails.map(({dataset}) => dataset.thumbnailMediaId)
			);

			let shouldRefresh = false;

			// add items from new data not present in DOM
			for (let i = mediaGalleryDestinationThumbnails.length - 1; i >= 0; i--) {
				if (
					!sourceSetThumbnails.has(
						mediaGalleryDestinationThumbnails[i].dataset.thumbnailMediaId
					)
				) {
					thumbnailGallerySource.prepend(mediaGalleryDestinationThumbnails[i]);
					shouldRefresh = true;
				}
			}

			// remove items from DOM not present in new data
			for (let i = 0; i < mediaGallerySourceThumbnails.length; i++) {
				if (
					!destinationSetThumbnails.has(
						mediaGallerySourceThumbnails[i].dataset.thumbnailMediaId
					)
				) {
					mediaGallerySourceThumbnails[i].remove();
					shouldRefresh = true;
				}
			}

			// refresh
			if (shouldRefresh) {
				[mediaGallerySourceThumbnails, sourceSetThumbnails, sourceMapThumbnails] =
					refreshThumbnailSourceData();
			}

			// if media galleries don't match, sort to match new data order
			mediaGalleryDestinationThumbnails.forEach((destinationItem, destinationIndex) => {
				const sourceData = sourceMapThumbnails.get(destinationItem.dataset.mediaId);

				if (sourceData && sourceData.index !== destinationIndex) {
					mediaGallerySourceThumbnails.insertBefore(
						sourceData.item,
						mediaGallerySourceThumbnails.querySelector(
							`li:nth-of-type(${destinationIndex + 1})`
						)
					);

					// refresh source now that it has been modified
					[mediaGallerySourceThumbnails, sourceSetThumbnails, sourceMapThumbnails] =
						refreshSourceData();
				}
			});
		}

		document
			.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
			.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media?.id}`);

		document.querySelector(`[id^="MediaGallery-${this.dataset.section}"]`).updateElements();

		if (thumbnailGallerySource && thumbnailGallerySource.closest('product-slider')) {
			thumbnailGallerySource.closest('product-slider').onImageUpdate();
		}

		if (mediaGallerySource && mediaGallerySource.closest('product-slider')) {
			mediaGallerySource.closest('product-slider').onImageUpdate();
		}

		// update media modal
		const modalContent = document.querySelector(
			`#ProductModal-${this.dataset.section} .product-media-modal__content`
		);
		const newModalContent = html.querySelector(`product-modal .product-media-modal__content`);
		if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
	}

	renderProductInfo() {
		const requestedVariantId = this.currentVariant.id;
		const sectionId = this.dataset.originalSection
			? this.dataset.originalSection
			: this.dataset.section;

		fetch(
			`${this.dataset.url}?variant=${requestedVariantId}&section_id=${
				this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section
			}`
		)
			.then((response) => response.text())
			.then((responseText) => {
				// prevent unnecessary ui changes from abandoned selections
				if (this.currentVariant.id !== requestedVariantId) return;

				const html = new DOMParser().parseFromString(responseText, 'text/html');
				const destination = document.getElementById(`price-${this.dataset.section}`);
				const source = html.getElementById(
					`price-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuSource = html.getElementById(
					`Sku-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
				const inventorySource = html.getElementById(
					`Inventory-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);
				const inventoryDestination = document.getElementById(
					`Inventory-${this.dataset.section}`
				);

				const volumePricingSource = html.getElementById(
					`Volume-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);

				this.updateMedia(html);

				const pricePerItemDestination = document.getElementById(
					`Price-Per-Item-${this.dataset.section}`
				);
				const pricePerItemSource = html.getElementById(
					`Price-Per-Item-${
						this.dataset.originalSection
							? this.dataset.originalSection
							: this.dataset.section
					}`
				);

				const volumePricingDestination = document.getElementById(
					`Volume-${this.dataset.section}`
				);
				const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
				const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

				if (volumeNote) volumeNote.classList.remove('hidden');
				if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
				if (qtyRules) qtyRules.classList.remove('hidden');

				if (source && destination) destination.innerHTML = source.innerHTML;
				if (inventorySource && inventoryDestination)
					inventoryDestination.innerHTML = inventorySource.innerHTML;
				if (skuSource && skuDestination) {
					skuDestination.innerHTML = skuSource.innerHTML;
					skuDestination.classList.toggle(
						'hidden',
						skuSource.classList.contains('hidden')
					);
				}

				if (volumePricingSource && volumePricingDestination) {
					volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
				}

				if (pricePerItemSource && pricePerItemDestination) {
					pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
					pricePerItemDestination.classList.toggle(
						'hidden',
						pricePerItemSource.classList.contains('hidden')
					);
				}

				const price = document.getElementById(`price-${this.dataset.section}`);

				if (price) price.classList.remove('hidden');

				if (inventoryDestination)
					inventoryDestination.classList.toggle(
						'hidden',
						inventorySource.innerText === ''
					);

				const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
				this.toggleAddButton(
					addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
					window.variantStrings.soldOut
				);

				const tabs = document.getElementById(`product-tabs--${this.dataset.section}`);
				const newTabs = html.getElementById(`product-tabs--${sectionId}`);

				if (tabs && newTabs) {
					tabs.innerHtml = '';
					tabs.innerHTML = newTabs.innerHTML;
				}

				const deliveryEstimate = document.getElementById(
					`delivery-estimate--${this.dataset.section}`
				);
				const newDeliveryEstimate = html.getElementById(
					`delivery-estimate--${this.dataset.section}`
				);

				if (deliveryEstimate && newDeliveryEstimate) {
					deliveryEstimate.innerHtml = '';
					deliveryEstimate.innerHTML = newDeliveryEstimate.innerHTML;
				}

				const stock = document.getElementById(`product-stock--${this.dataset.section}`);
				const newStock = html.getElementById(`product-stock--${sectionId}`);

				if (stock && newStock) {
					stock.innerHtml = '';
					stock.innerHTML = newStock.innerHTML;
				}

				const reviewSave = document.getElementById(
					`product-review-save--${this.dataset.section}`
				);
				const newReviewSave = html.getElementById(`product-review-save--${sectionId}`);

				if (reviewSave && newReviewSave) {
					reviewSave.innerHtml = '';
					reviewSave.innerHTML = newReviewSave.innerHTML;
				}

				const reviewSaveSofa = document.getElementById(
					`product-review-save-sofa--${this.dataset.section}`
				);
				const newReviewSaveSofa = html.getElementById(
					`product-review-save-sofa--${sectionId}`
				);

				if (reviewSaveSofa && newReviewSaveSofa) {
					reviewSaveSofa.innerHtml = '';
					reviewSaveSofa.innerHTML = newReviewSaveSofa.innerHTML;
				}

				const fobPrice = document.getElementById(`product-fob--${this.dataset.section}`);
				const newFobPrice = html.getElementById(`product-fob--${sectionId}`);

				if (fobPrice && newFobPrice) {
					fobPrice.innerHtml = '';
					fobPrice.innerHTML = newFobPrice.innerHTML;
				}

				const orderSwatches = document.getElementById(
					`product-order-swatches--${this.dataset.section}`
				);
				const newOrderSwatches = html.getElementById(
					`product-order-swatches--${sectionId}`
				);

				if (orderSwatches && newOrderSwatches) {
					orderSwatches.innerHtml = '';
					orderSwatches.innerHTML = newOrderSwatches.innerHTML;
				}

				const selectedLabels = this.querySelectorAll('[data-selected-option-value]');
				const newSelectedLabels = html.querySelectorAll('[data-selected-option-value]');
				selectedLabels.forEach((label, index) => {
					const matchingLabel = newSelectedLabels[index] || null;
					if (matchingLabel) {
						label.textContent = matchingLabel.textContent;
					}
				});

				// const arrangements = document.getElementById(
				// 	`sofa-arrangements--${this.dataset.section}`
				// );
				// const newArrangements = html.getElementById(`sofa-arrangements--${sectionId}`);

				// if (arrangements && newArrangements) {
				// 	arrangements.innerHtml = '';
				// 	arrangements.innerHTML = newArrangements.innerHTML;
				// }

				publish(PUB_SUB_EVENTS.variantChange, {
					data: {
						sectionId,
						html,
						variant: this.currentVariant
					}
				});
			});
	}

	toggleAddButton(disable = true, text, modifyClass = true) {
		const productForm = document.getElementById(`product-form-${this.dataset.section}`);
		if (!productForm) return;
		const addButton = productForm.querySelector('[name="add"]');
		const addButtonText = productForm.querySelector('[name="add"] > span');
		if (!addButton) return;

		if (disable) {
			addButton.setAttribute('disabled', 'disabled');
			if (text) addButtonText.textContent = text;
		} else {
			addButton.removeAttribute('disabled');
			addButtonText.textContent = window.variantStrings.addToCart;
		}

		if (!modifyClass) return;
	}

	setUnavailable() {
		const button = document.getElementById(`product-form-${this.dataset.section}`);
		const addButton = button.querySelector('[name="add"]');
		const addButtonText = button.querySelector('[name="add"] > span');
		const price = document.getElementById(`price-${this.dataset.section}`);
		const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
		const sku = document.getElementById(`Sku-${this.dataset.section}`);
		const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
		const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
		const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
		const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

		if (!addButton) return;
		addButtonText.textContent = window.variantStrings.unavailable;
		if (price) price.classList.add('hidden');
		if (inventory) inventory.classList.add('hidden');
		if (sku) sku.classList.add('hidden');
		if (pricePerItem) pricePerItem.classList.add('hidden');
		if (volumeNote) volumeNote.classList.add('hidden');
		if (volumeTable) volumeTable.classList.add('hidden');
		if (qtyRules) qtyRules.classList.add('hidden');
	}

	getVariantData() {
		this.variantData =
			this.variantData ||
			JSON.parse(this.querySelector('[type="application/json"]').textContent);
		return this.variantData;
	}
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
	constructor() {
		super();
		this.id = this.getAttribute('data-id');
	}

	connectedCallback() {
		const handleIntersection = (entries, observer) => {
			if (!entries[0].isIntersecting) return;
			observer.unobserve(this);

			fetch(this.dataset.url)
				.then((response) => response.text())
				.then((text) => {
					const markupReturn = new DOMParser().parseFromString(text, 'text/html');
					if (!markupReturn || markupReturn.querySelector('parsererror')) {
						this.remove();
						return;
					}
					// Recommendations are returned in a dynamic structure without a single wrapper
					// We grab all the child nodes within recommendations and append them
					const nodes = Array.from(
						markupReturn.querySelector('product-recommendations').childNodes
					);
					if (!nodes.length) {
						this.remove();
						return;
					}
					this.textContent = '';
					nodes.forEach((node) => {
						this.appendChild(node);
					});

					if (
						!this.querySelector('slideshow-component') &&
						this.classList.contains('complementary-products') &&
						!this.querySelector('glide-component')
					) {
						this.remove();
					}

					const glide = this.querySelector('glide-component');
					if (glide) {
						const updateGlide = new CustomEvent('updateGlide', {
							detail: [
								{
									id: this.id
								}
							]
						});
						document.dispatchEvent(updateGlide);
					}

					if (this.querySelector('.grid__item')) {
						this.classList.add('product-recommendations--loaded');
					}
				})
				.catch((e) => {
					console.error(e);
				});
		};

		new IntersectionObserver(handleIntersection.bind(this), {
			rootMargin: '0px 0px 400px 0px'
		}).observe(this);
	}
}

customElements.define('product-recommendations', ProductRecommendations);

class AccordionComponent extends HTMLElement {
	constructor() {
		super();

		// The toggle button
		this.toggle = this.querySelector('[data-toggle]');
		// The content body
		this.content = this.querySelector('[data-content]');
		// Other accordions within the same container
		this.siblings = this.parentElement.querySelectorAll('accordion-component');
		// For scenarios where we only want to display the accordion options on mobile
		// This will show the content by default on desktop and hide it on mobile, as well as make it non-interactable on desktop
		this.disableDesktop = this.hasAttribute('data-disable-desktop')
			? this.getAttribute('data-disable-desktop')
			: false;
		// Holds our animation duration for timers
		this.duration = this.hasAttribute('data-duration')
			? parseInt(this.getAttribute('data-duration'), 10)
			: 100;
		this.timer = null;
		// Holds our open/closed state
		this.expanded = this.classList.contains('accordion__item--open') ? true : false;
		// Mobile Safari contextual UI can cause a resize event
		// We only want to trigger our state changes on real resize events - this holds a comparison width so we can prevent such triggers
		this.cachedWidth = window.innerWidth;

		if (!this.toggle || !this.content) return;

		this.initialize();
	}

	initialize() {
		this.toggle.addEventListener('click', this.toggleAccordion.bind(this));
		if (this.disableDesktop == 'true') {
			window.addEventListener(
				'resize',
				debounce((event) => {
					this.onResize();
				}, 300).bind(this)
			);
			// Open by default on desktop when desktop controls are disabled
			// For some reason innerwidth is incorrectly reported unless we wait for the 'load' event
			window.addEventListener('load', () => {
				if (window.innerWidth > 749) {
					this.openAccordion();
				}
			});
		}
		this.toggleFocusable();
	}

	onResize() {
		const width = window.innerWidth;
		if (width === this.cachedWidth) return;
		this.cachedWidth = width;
		if (this.disableDesktop == 'true' && width < 750 && this.expanded) {
			this.closeAccordion();
		}
		if (this.disableDesktop == 'true' && width > 749 && !this.expanded) {
			this.openAccordion();
		}
	}

	toggleAccordion() {
		clearTimeout(this.timer);
		if (this.disableDesktop == 'true' && window.innerWidth > 749) return;
		if (this.expanded) {
			this.closeAccordion();
		} else {
			this.closeSiblings();
			this.openAccordion();
		}
	}

	openAccordion() {
		const accordion = this;
		this.expanded = true;
		this.classList.add('accordion__item--open');
		this.toggle.setAttribute('aria-expanded', true);
		this.content.setAttribute('aria-hidden', false);
		// Add additional height to account for the padding applied to our content
		this.content.style.maxHeight = this.content.scrollHeight + 24 + 'px';
		// Reset the max-height parameter to initial to allow responsive scaling
		this.timer = setTimeout(() => {
			accordion.content.style.maxHeight = 'initial';
		}, accordion.duration);
		this.toggleFocusable();
	}

	closeAccordion() {
		this.expanded = false;
		// Reset the max-height parameter to our set max-height to begin the animation
		// If max-height is not set to an exact value the animation will not trigger
		this.content.style.maxHeight = this.content.scrollHeight + 24 + 'px';
		// Add timeout without a parameter to start a new thread
		// Alows the max-height reset above to process and avoids animation jank
		setTimeout(() => {
			this.classList.remove('accordion__item--open');
			this.toggle.setAttribute('aria-expanded', false);
			this.content.setAttribute('aria-hidden', true);
			this.content.style.maxHeight = null;
			this.toggleFocusable();
		});
	}

	toggleFocusable() {
		const focusable = getFocusableElements(this.content);
		if (this.expanded) {
			focusable.forEach((element) => {
				element.removeAttribute('tabindex');
			});
		} else {
			focusable.forEach((element) => {
				element.setAttribute('tabindex', '-1');
			});
		}
	}

	closeSiblings() {
		if (!this.siblings || !this.siblings.length) return;

		for (var x = 0; x < this.siblings.length; x++) {
			if (this.siblings[x] === this || this.siblings[x].expanded === false) continue;
			this.siblings[x].closeAccordion();
		}
	}
}

customElements.define('accordion-component', AccordionComponent);

class DynamicListBlock extends HTMLElement {
	constructor() {
		super();
		this.mobileIndex = this.getAttribute('data-mobile-index');
		this.index = this.getAttribute('data-index');
		this.largeIndex = this.getAttribute('data-large-index');
		this.extraLargeIndex = this.getAttribute('data-extra-large-index');
		this.wrapperID = this.getAttribute('data-wrapper');

		if (
			!this.mobileIndex ||
			!this.index ||
			!this.largeIndex ||
			!this.extraLargeIndex ||
			!this.wrapperID
		)
			return;

		this.wrapper = this.closest(`#${this.wrapperId}`);
		if (!this.wrapper) this.wrapper = this.closest(`.${this.wrapperID}`);
		if (!this.wrapper) return;

		this.bind();
		this.inject();
	}

	bind() {
		const block = this;
		window.addEventListener(
			'resize',
			debounce((event) => {
				block.inject();
			}, 50).bind(this)
		);
	}

	inject() {
		const injectIndex =
			window.innerWidth > 949 && window.innerWidth < 1920
				? this.index - 1
				: window.innerWidth >= 1920 && window.innerWidth < 2560
				? this.largeIndex - 1
				: window.innerWidth >= 2560
				? this.extraLargeIndex - 1
				: this.mobileIndex - 1;

		if (!this.wrapper.children[injectIndex]) return;

		this.classList.remove('hidden');

		// On resize relocate rather than re-append
		const existingBlock = this.wrapper.querySelector('.curated-block');
		if (
			existingBlock &&
			this.wrapper.children[this.wrapper.children.length - 1] !== existingBlock
		) {
			if (this.wrapper.children[injectIndex] === this) return;
			if (window.innerWidth > 989 && window.innerWidth < 1920) {
				this.wrapper.insertBefore(this, this.wrapper.children[injectIndex]);
			} else if (window.innerWidth >= 1920) {
				this.wrapper.insertBefore(this, this.wrapper.children[injectIndex + 1]);
			} else {
				this.wrapper.insertBefore(this, this.wrapper.children[injectIndex + 1]);
			}
			return;
		}

		this.wrapper.insertBefore(this, this.wrapper.children[injectIndex]);
	}
}

customElements.define('dynamic-list-block', DynamicListBlock);

class ProductCardSwatches extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.data = this.querySelector("script[type='application/json']");
		if (!this.data) return;
		this.data = this.data.textContent;
		this.data = JSON.parse(this.data);
		this.swatches = this.querySelectorAll('[data-swatch-variant]');
		if (!this.swatches.length) return;
		const currentVariant = this.querySelector('.selected');
		if (this.currentVariant)
			this.currentVariant = this.currentVariant.getAttribute('data-swatch-variant');
		this.bind();
	}

	bind() {
		const component = this;
		component.swatches.forEach((swatch) => {
			swatch.addEventListener('click', function () {
				const id = swatch.getAttribute('data-swatch-variant');
				if (!id) return;
				component.currentVariant = parseInt(id, 10);
				component.updateVariant();
			});
		});
		component.swatches.forEach((swatch) => {
			swatch.addEventListener('mouseover', function () {
				const id = swatch.getAttribute('data-swatch-variant');
				if (!id) return;
				component.currentVariant = parseInt(id, 10);
				component.updateVariant();
			});
		});
	}

	updateVariant() {
		const card = this.closest('.card-wrapper');
		const variant = this.data.find((variant) => {
			return variant.id === this.currentVariant;
		});
		``;

		const productImage = card.getElementsByClassName('product-image')[0];
		if (variant.featured_image) {
			productImage.src = `${variant.featured_image}&width=533`;
		}

		//const modifier = variant.url.indexOf('?') != -1 ? '&' : '?';

		const variantUrl = `${variant.url}`;

		const cardLinks = card.querySelectorAll('a');
		cardLinks.forEach((link) => {
			link.setAttribute('href', variantUrl);
		});

		this.swatches.forEach((swatch) => {
			if (swatch.getAttribute('data-swatch-variant') == this.currentVariant) {
				swatch.classList.add('selected');
			} else {
				swatch.classList.remove('selected');
			}
		});

		const priceWrapper = card.querySelector('.card-information__wrapper .price');
		const regularPriceWrapper = card.querySelector('.price__regular .money');
		const compareAtPriceWrapper = card.querySelector('.price__sale .price-item--regular');
		let compareAtPriceText = compareAtPriceWrapper?.querySelector('.money');
		const salePriceWrapper = card.querySelector('.price__sale .price-item--last .money');

		let variantPrice = variant.price;
		variantPrice = variantPrice / 100;
		variantPrice = variantPrice.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
		variantPrice = variantPrice.slice(0, -3);
		variantPrice = variantPrice.replace(',', '');
		let compareAtPrice = variant.compare_at_price;

		if (compareAtPrice) {
			compareAtPrice = compareAtPrice / 100;
			compareAtPrice = compareAtPrice.toLocaleString('en-US', {
				style: 'currency',
				currency: 'USD'
			});
			compareAtPrice = compareAtPrice.slice(0, -3);
			compareAtPrice = compareAtPrice.replace(',', '');
		}

		if (regularPriceWrapper) {
			regularPriceWrapper.innerText = variantPrice;
		}
		if (salePriceWrapper) {
			salePriceWrapper.innerText = variantPrice;
		}

		if (compareAtPriceWrapper && priceWrapper) {
			if (!compareAtPriceText) {
				const textHolder = document.createElement('span');
				textHolder.classList.add('money');
				compareAtPriceWrapper.appendChild(textHolder);
				compareAtPriceText = compareAtPriceWrapper.querySelector('.money');
			}
			if (compareAtPrice) {
				compareAtPriceText.textContent = compareAtPrice;
				compareAtPriceText.style.display = 'inline';
				priceWrapper.classList.add('price--on-sale');
			} else {
				compareAtPriceText.style.display = 'none';
				priceWrapper.classList.remove('price--on-sale');
			}
		}

		const channelsightPrice = this.parentElement.querySelector('channelsight-price');
		if (channelsightPrice) {
			channelsightPrice.setAttribute('data-barcode', variant.barcode);
		}
	}
}

customElements.define('product-card-swatches', ProductCardSwatches);

class ChannelsightPrice extends HTMLElement {
	static observedAttributes = ['data-barcode'];
	constructor() {
		super();
		this.connected = false;
	}

	connectedCallback() {
		this.connected = true;
		this.shopifyPrice = this.querySelector('.price');
		this.lowestPrice = this.querySelector('.lowest-price');
		this.spinner = this.querySelector('.price-spinner');
		this.couponCode = this.querySelector('.discount-coupon');
		this.price = this.getAttribute('data-price')
			? parseInt(this.getAttribute('data-price'), 10) / 100
			: null;
		this.disableOutofStock = true;
		this.availabilityTypes = {
			inStock: 'InStock'
		};
		this.initialize();
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (!this.connected) return;
		if (oldValue !== newValue) this.initialize();
	}

	initialize() {
		this.barcode = this.getAttribute('data-barcode');
		this.retailerProducts = [];

		if (!this.barcode) {
			this.hideSpinner();
			this.showShopifyPrice();
			return;
		}
		this.fetchPrices();
	}

	fetchPrices() {
		if (this.submitting) {
			this.submitting = false;
			this.controller.abort();
		}
		this.controller = new AbortController();
		this.signal = this.controller.signal;
		this.submitting = true;
		this.showSpinner();
		this.hidePrices();
		fetch(
			`https://api.channelsight.com/api/2.14/feed?key=c4d11394-8ab1-4b18-9f03-f9abf4a51dbf&assetId=5589&pid=${this.barcode}`,
			{
				method: 'get',
				signal: this.signal
			}
		)
			.then(function (response) {
				if (!response.ok) {
					return Promise.reject(result);
				}
				return response.json();
			})
			.then((response) => {
				if (
					!response.length ||
					!response[0].RetailerProducts ||
					!response[0].RetailerProducts.length
				) {
					this.showShopifyPrice();
					return;
				}
				this.retailerProducts = response[0].RetailerProducts;
				this.generatePrice();
			})
			.catch((err) => {
				console.error(err);
				this.showShopifyPrice();
			})
			.finally(() => {
				this.submitting = false;
				this.hideSpinner();
			});
	}

	generatePrice() {
		const retailerProducts = [];
		this.retailerProducts.forEach((product) => {
			if (product.Price !== 0) retailerProducts.push(product);
		});
		const cheapestRetailer = retailerProducts.reduce((prev, curr) => {
			if (!this.disableOutofStock) {
				return prev.Price < curr.Price ? prev : curr;
			} else {
				if (curr.Availability !== this.availabilityTypes.inStock) {
					return false;
				}
				return prev.Price < curr.Price ? prev : curr;
			}
		});

		if (
			!cheapestRetailer ||
			(cheapestRetailer && this.price && this.price <= cheapestRetailer.Price)
		) {
			this.showShopifyPrice();
			return;
		}
		const price = cheapestRetailer.RetailerCurrencySymbol + Math.ceil(cheapestRetailer.Price);
		this.lowestPrice.textContent = `${window.variantStrings.from} ${price}`;
		this.showLowestPrice();
	}

	hidePrices() {
		this.lowestPrice?.classList.add('hidden');
		this.shopifyPrice?.classList.add('hidden');
	}

	hideSpinner() {
		this.spinner?.classList.add('hidden');
	}

	showSpinner() {
		this.spinner?.classList.remove('hidden');
	}

	showLowestPrice() {
		this.lowestPrice?.classList.remove('hidden');
		this.shopifyPrice?.classList.add('hidden');
		this.couponCode?.classList.add('hidden');
	}

	showShopifyPrice() {
		this.lowestPrice?.classList.add('hidden');
		this.shopifyPrice?.classList.remove('hidden');
		this.couponCode?.classList.remove('hidden');
	}
}

customElements.define('channelsight-price', ChannelsightPrice);

class BackInStockForm extends HTMLElement {
	constructor() {
		super();
	}
	connectedCallback() {
		this.email = null;
		this.disabled = false;
		this.emailInput = this.querySelector("input[name='email']");
		this.submitButton = this.querySelector('button');
		this.successMessage = this.querySelector('[data-success]');
		this.errorMessage = this.querySelector('[data-error]');
		this.variantId = this.querySelector("input[name='variant']")
			? this.querySelector("input[name='variant']").value
			: null;
		if (
			!this.emailInput ||
			!this.submitButton ||
			!this.successMessage ||
			!this.errorMessage ||
			!this.variantId
		)
			return;
		this.bind();
	}

	disconnectedCallback() {
		this.unbind();
	}

	bind() {
		this.onSubmitHandler = this.onSubmit.bind(this);
		this.submitButton.addEventListener('click', this.onSubmitHandler);
	}

	unbind() {}

	onSubmit() {
		if (this.disabled) return;
		this.email = this.emailInput.value;
		if (!this.email) return;
		this.disabled = true;
		this.submitButton.classList.add('custom-button--loading');
		const options = {
			method: 'POST',
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			},
			body: new URLSearchParams({
				a: 'SyKUrQ',
				email: this.email,
				variant: this.variantId,
				platform: 'shopify'
			})
		};
		fetch(`//a.klaviyo.com/onsite/components/back-in-stock/subscribe`, options)
			.then((response) => {
				return response.json();
			})
			.then((response) => {
				if (response.success) {
					this.successMessage.classList.remove('hidden');
					this.errorMessage.classList.add('hidden');
				} else {
					throw new Error(response.message);
				}
			})
			.catch((error) => {
				console.error('Error:', error);
				this.successMessage.classList.add('hidden');
				this.errorMessage.classList.remoe('hidden');
			})
			.finally(() => {
				this.disabled = false;
				this.submitButton.classList.remove('custom-button--loading');
			});
	}
}

customElements.define('back-in-stock-form', BackInStockForm);

class StickyBarService {
	constructor() {
		this.loaded = false;
		this.alignments = {
			top: 'top',
			bottom: 'bottom'
		};
		this.elements = [];
		this.displayedElements = {
			top: [],
			bottom: [],
			inline: []
		};
		this.footer = document.querySelector('footer');
		this.inlineRootMargin = `0px 0px 0px 0px`;
		const tasks = [
			this.getHeaderHeight.bind(this),
			this.setRootMargins.bind(this),
			this.setHandlers.bind(this)
		];

		this.yieldTasks(tasks);
	}

	yieldToMain() {
		return new Promise((resolve) => {
			setTimeout(resolve, 0);
		});
	}

	async yieldTasks(tasks) {
		while (tasks.length > 0) {
			const task = tasks.shift();
			task();
			await this.yieldToMain();
		}
	}

	onLoad() {
		this.loaded = true;
		this.setElementObservers();
		this.setInlineObservers();
	}

	onResize(entries) {
		const previousHeaderHeight = this.headerHeight;
		this.getHeaderHeight();
		this.setRootMargins();
		const alignmentsToUpdate = [];
		alignmentsToUpdate.push(this.alignments.top, this.alignments.bottom);
		this.displayedElements.inline.forEach((element) => {
			element.setHeight();
		});
		this.setElementOffsets(alignmentsToUpdate);
		this.setElementObservers();
		this.setInlineObservers();
	}

	onIntersect(entries) {
		entries.forEach((entry) => {
			if (entry.target.tagName.toLowerCase() === 'footer') {
				if (entry.isIntersecting) {
					this.hideElements([this.alignments.bottom]);
				} else {
					this.showElements([this.alignments.bottom]);
				}
				return;
			}
			const stickyBar = this.elements.find((element) => {
				return element.watchElement === entry.target;
			});
			const isVisible = entry.isIntersecting
				? true
				: (!entry.isIntersecting && window.scrollY >= entry.boundingClientRect.top) ||
				  entry.boundingClientRect.bottom < 0
				? false
				: true;

			if (isVisible && stickyBar.isVisible) {
				this.disableElement(stickyBar);
			} else if (!isVisible && !stickyBar.isVisible) {
				this.enableElement(stickyBar);
			}
			publish(PUB_SUB_EVENTS.stickyBarUpdate, {
				source: 'sticky-bar-service'
			});
		});
	}

	setHandlers() {
		this.unsubscribeHandler = this.unsubscribe.bind(this);

		this.resizeHandler = this.onResize.bind(this);
		this.resizeObserver = new ResizeObserver((entries) => this.resizeHandler(entries));

		this.intersectionHandler = this.onIntersect.bind(this);

		// Browser auto-scroll on window load bypasses interesection observers
		// We need to wait to actually start observing until after the page load event has fired
		if (document.readyState == 'complete') {
			this.onLoad();
		} else {
			window.addEventListener('load', () => this.onLoad());
		}
	}

	setRootMargins() {
		this.rootMargin = `-${this.headerHeight}px 0px 0px 0px`;
		this.updateInlineMargins();
	}

	updateInlineMargins() {
		let offset = this.headerHeight;
		let priorDisplayed = false;
		let firstElement = true;
		this.elements.forEach((element) => {
			if (element.inline) {
				// Visible elements always add to the offset
				if (element.isVisible) {
					priorDisplayed = true;
					offset += element.currentHeight + element.ignoreHeight;
				}
				// Next immediate bar from a visible bar also adds it's own ignore offset and flips the boolean back
				else if (!element.isVisible && priorDisplayed) {
					priorDisplayed = false;
					offset += element.ignoreHeight;
				}
				// The first bar always adds it's ignore offset regardless of display
				else if (firstElement && !element.isVisible) {
					offset += element.ignoreHeight;
					firstElement = false;
				}
			}
		});
		if (offset > 0) offset = offset * -1;
		this.inlineRootMargin = `${offset}px 0px 0px 0px`;
	}

	enableElement(element) {
		const matchingElement = this.elements.find((el) => {
			return el === element;
		});
		if (!matchingElement) return;
		const existing = this.displayedElements[matchingElement.alignment].indexOf(matchingElement);
		if (existing !== -1) {
			this.displayedElements[matchingElement.alignment].splice(existing, 1);
		}
		this.displayedElements[matchingElement.alignment]?.push(matchingElement);
		if (matchingElement.inline) {
			const existingInline = this.displayedElements.inline.indexOf(matchingElement);
			if (existingInline !== -1) {
				this.displayedElements.inline.splice(existingInline, 1);
			}
			this.displayedElements.inline.push(matchingElement);
		}
		this.setElementOffsets([matchingElement.alignment]);
		matchingElement.show();
	}

	disableElement(element) {
		const matchingElement = this.elements.find((el) => {
			return el === element;
		});
		if (!matchingElement) return;
		matchingElement.hide();
		this.displayedElements[matchingElement.alignment] = this.displayedElements[
			matchingElement.alignment
		]?.filter((el) => {
			return el !== element;
		});
		if (this.displayedElements.inline.length) {
			this.displayedElements.inline = this.displayedElements.inline.filter((el) => {
				return el !== element;
			});
		}
		this.setElementOffsets([matchingElement.alignment]);
	}

	hideElements(alignments) {
		if (!alignments?.length) return;
		alignments.forEach((alignment) => {
			this.displayedElements[alignment]?.forEach((element) => {
				element.hide();
			});
		});
	}

	showElements(alignments) {
		if (!alignments?.length) return;
		alignments.forEach((alignment) => {
			this.displayedElements[alignment]?.forEach((element) => {
				element.show();
			});
		});
	}

	setElementObservers() {
		this.intersectionObserver?.disconnect();
		this.intersectionObserver = new IntersectionObserver(
			(entries) => this.intersectionHandler(entries),
			{threshold: 0, rootMargin: this.rootMargin}
		);
		this.intersectionObserver?.observe(this.footer);
		this.elements.forEach((element) => {
			if (this.loaded && !element.inline)
				this.intersectionObserver.observe(element.watchElement);
		});
	}

	setInlineObservers() {
		this.intersectionObserverInline?.disconnect();
		this.intersectionObserverInline = new IntersectionObserver(
			(entries) => this.intersectionHandler(entries),
			{threshold: 0, rootMargin: this.inlineRootMargin}
		);
		this.elements.forEach((element) => {
			if (this.loaded && element.inline) {
				this.intersectionObserverInline.observe(element.watchElement);
			}
		});
	}

	setElementOffsets(alignments) {
		if (!alignments?.length) return;
		alignments.forEach((alignment) => {
			let offset = 0;
			this.displayedElements[alignment]?.forEach((element, index) => {
				offset += element.offset;
				if (index === 0) {
					offset += alignment === this.alignments.top ? this.headerHeight : 0;
				}
				element.style.setProperty('--offset', `${offset}px`);

				offset += element.offsetHeight;
				offset += element.ignoreHeight;
			});
		});
	}

	getHeaderHeight() {
		this.header = document.querySelector('.header-wrapper');
		if (!this.header) return;
		this.headerType = this.header.tagName.toLowerCase();
		this.headerStickyType = this.header.getAttribute('data-sticky-type');
		this.headerHeight = this.headerStickyType === 'always' ? this.header.offsetHeight : 0;
	}

	subscribe(element) {
		if (!this.elements.length) {
			this.getHeaderHeight();
			this.resizeObserver.observe(this.header);
		}
		if (this.loaded && !element.inline)
			this.intersectionObserver?.observe(element.watchElement);
		this.elements.push(element);
		if (element.inline && !this.displayedElements.inline.length) {
			this.updateInlineMargins();
			this.setInlineObservers();
		}
		return () => this.unsubscribeHandler(element);
	}

	unsubscribe(element) {
		if (!element) return;
		this.elements = this.elements.filter((el) => {
			return el !== element;
		});
		if (element.inline) {
			this.intersectionObserverInline?.unobserve(element.watchElement);
		} else {
			this.intersectionObserver?.unobserve(element.watchElement);
		}
		if (!this.elements.length) this.resizeObserver.disconnect();
	}
}

p80.stickyBarService = new StickyBarService();
class StickyBar extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.isVisible = false;
		this.animationDuration = 200;
		this.fadeTimer = null;
		const tasks = [
			this.setConfiguration.bind(this),
			this.initializeWatchElement.bind(this),
			this.subscribe.bind(this)
		];
		this.yieldTasks(tasks);
	}

	disconnectedCallback() {
		if (this.stickyBarUnsubscriber) this.stickyBarUnsubscriber();
	}

	yieldToMain() {
		return new Promise((resolve) => {
			setTimeout(resolve, 0);
		});
	}

	async yieldTasks(tasks) {
		while (tasks.length > 0) {
			const task = tasks.shift();
			task();
			await this.yieldToMain();
		}
	}

	setConfiguration() {
		this.style.setProperty(`--sticky-animation-duration`, `${this.animationDuration}ms`);
		this.alignment = this.hasAttribute('data-alignment')
			? p80.stickyBarService.alignments[this.getAttribute('data-alignment')]
			: 'top';
		const offset = this.getAttribute('data-offset');
		const offsetSplit = offset?.match(/^([-.\d]+(?:\.\d+)?)(.*)$/);
		const offsetSize = offsetSplit?.length ? offsetSplit[1] : null;
		this.offset = !Number.isNaN(parseInt(offsetSize, 10)) ? parseInt(offsetSize, 10) : 0;
		this.offsetUnit = offsetSplit?.length ? offsetSplit[2] : 'px';
		this.inline = this.getAttribute('data-inline') == 'true' ? true : false;
		this.inlineContainer = this.querySelector('[data-inline-container]');
		this.ignoreHeight = 0;
		this.ignoreElementsMobile = this.querySelectorAll('[data-ignore-mobile]');
		this.ignoreElementsTablet = this.querySelectorAll('[data-ignore-tablet]');
		this.ignoreElementsDesktop = this.querySelectorAll('[data-ignore-desktop]');
		if (this.inline && this.inlineContainer) {
			this.watchElement = this;
			this.classList.add('sticky-bar--inline', 'sticky-bar--top', 'sticky-bar--fade-in');
			this.setHeight();
			return;
		}
		this.classList.add(`sticky-bar--${this.alignment}`);
	}

	subscribe() {
		if (!this.watchElement) {
			console.error('Required configuration not provided.');
			this.classList.add('hidden');
			return;
		}
		this.stickyBarUnsubscriber = p80.stickyBarService.subscribe(this);
	}

	initializeWatchElement() {
		if (this.inline && this.watchElement) {
			return;
		}
		this.watchElementId = this.hasAttribute('data-watch-element')
			? this.getAttribute('data-watch-element')
			: null;
		if (!this.watchElementId) {
			console.error('No watch element selector set for the Sticky Bar');
			this.classList.add('hidden');
			return;
		}
		this.watchElement = document.querySelector(this.watchElementId);
		if (!this.watchElement) {
			console.error(`Unable to find the watch element with the ID ${this.watchElementId}`);
			this.classList.add('hidden');
			return;
		}
	}

	fadeIn() {
		clearTimeout(this.fadeTimer);
		this.classList.add('sticky-bar--fade-out');
		this.fadeTimer = setTimeout(() => {
			this.classList.add('sticky-bar--sticky');
			this.classList.remove('sticky-bar--fade-out');
			this.fadeTimer = setTimeout(() => {
				this.classList.add('sticky-bar--fade-in');
				this.isVisible = true;
				p80.stickyBarService.updateInlineMargins();
				p80.stickyBarService.setInlineObservers();
			});
		}, this.animationDuration);
	}

	fadeOut() {
		clearTimeout(this.fadeTimer);
		this.classList.add('sticky-bar--fade-out');
		this.fadeTimer = setTimeout(() => {
			this.classList.remove('sticky-bar--fade-out');
			this.classList.remove('sticky-bar--sticky');
			this.fadeTimer = setTimeout(() => {
				this.classList.add('sticky-bar--fade-in');
				this.isVisible = false;
				p80.stickyBarService.updateInlineMargins();
				p80.stickyBarService.setInlineObservers();
			});
		}, this.animationDuration);
	}

	show() {
		if (this.inline) {
			this.setHeight();
			this.fadeIn();
			return;
		}
		this.classList.add('sticky-bar--visible');
		this.isVisible = true;
	}

	hide() {
		if (this.inline) {
			this.fadeOut();
			return;
		}
	}

	setMobileIgnoreHeight() {
		this.ignoreElementsMobile.forEach((ignoreElement) => {
			this.ignoreHeight -= ignoreElement.offsetHeight;
		});
	}

	setTabletIgnoreHeight() {
		this.ignoreElementsTablet.forEach((ignoreElement) => {
			this.ignoreHeight -= ignoreElement.offsetHeight;
		});
	}

	setDesktopIgnoreHeight() {
		this.ignoreElementsDesktop.forEach((ignoreElement) => {
			this.ignoreHeight -= ignoreElement.offsetHeight;
		});
	}

	setHeight() {
		this.currentHeight = this.inlineContainer?.offsetHeight || 0;
		this.style.setProperty(`--sticky-content-height`, `${this.currentHeight}px`);
		this.ignoreHeight = 0;
		if (
			p80.mediaQueryService.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.small
		) {
			this.setMobileIgnoreHeight();
		} else if (
			p80.mediaQueryService.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.medium
		) {
			this.setTabletIgnoreHeight();
		} else if (
			p80.mediaQueryService.currentMediaQuery.type === p80.mediaQueryService.mediaTypes.large
		) {
			this.setDesktopIgnoreHeight();
		}
	}
}

customElements.define('sticky-bar', StickyBar);

class CollectionShowMore extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.id = this.dataset.id;
		if (!this.id) return;

		this.loading = false;
		this.page = this.dataset.page;
		this.totalPages = this.dataset.totalPages;
		if (!this.page || !this.totalPages) return;
		this.page = parseInt(this.page, 10);
		this.totalPages = parseInt(this.totalPages, 10);

		this.disabled = this.page === this.totalPages ? true : false;
		if (this.disabled) this.disable();

		this.button = this.querySelector('button');
		this.spinner = this.querySelector('.loading__spinner');

		this.handleOnClick = this.onClick.bind(this);
		this.onCollectionLoadUnubscriber = subscribe(PUB_SUB_EVENTS.collectionLoaded, (event) => {
			// Fuzzy match as the id for facets includes facets- on top of the ID
			if (!event.id.includes(this.id)) return;
			this.onCollectionLoad(event);
		});

		this.button?.addEventListener('click', this.handleOnClick);
	}

	disconnectedCallback() {
		this.button?.removeEventListener('click', this.handleOnClick);
		if (this.onCollectionLoadUnubscriber) this.onCollectionLoadUnubscriber();
	}

	onClick(event) {
		event.preventDefault();
		if (this.loading || this.page == this.totalPages || this.disabled) return;
		this.loading = true;
		this.showSpinner();
		publish(PUB_SUB_EVENTS.collectionUpdate, {
			source: 'CollectionShowMore',
			id: this.id,
			page: this.page + 1
		});
	}

	onCollectionLoad(event) {
		this.loading = false;
		this.page = event.page;
		this.page === this.totalPages ? this.disable() : this.enable();
		this.hideSpinner();
	}

	disable() {
		this.disabled = true;
		this.button?.classList.add('custom-button--disabled');
		this.button?.setAttribute('disabled', true);
	}

	enable() {
		this.disabled = false;
		this.button?.classList.remove('custom-button--disabled');
		this.button?.removeAttribute('disabled');
	}

	showSpinner() {
		this.spinner?.classList.remove('hidden');
	}

	hideSpinner() {
		this.spinner?.classList.add('hidden');
	}
}

customElements.define('collection-show-more', CollectionShowMore);

p80.updateCartCount = (count) => {
	const icon = document.querySelector('[data-cart-total]');
	const countIcon = icon.querySelector('.cart-count-bubble');
	if ((count <= 0 && countIcon) || (!count && countIcon)) {
		countIcon.remove();
	} else if (count) {
		const wrapper = document.createElement('div');
		wrapper.classList.add('cart-count-bubble');
		const aria = document.createElement('span');
		aria.setAttribute('aria-hidden', true);
		aria.innerText = count;
		const text = document.createElement('span');
		text.classList.add('visually-hidden');
		text.innerText = count;
		wrapper.appendChild(aria);
		wrapper.appendChild(text);
		icon.appendChild(wrapper);
	}
};

window.addEventListener('DOMContentLoaded', (event) => {
	if (location.hash) {
		const target = document.getElementById(location.hash.replace('#', ''));
		if (target) {
			target.scrollIntoView();
		}
	}
});
